export const ENTITY_DELETE = 'zola/wedding/website/entity/ENTITY_DELETE';
export const ENTITY_DELETED = 'zola/wedding/website/entity/ENTITY_DELETED';
export const ENTITY_REQUESTED = 'zola/wedding/website/entity/ENTITY_REQUESTED';
export const ENTITY_ADD = 'zola/wedding/website/entity/ENTITY_ADD';
export const ENTITY_RECEIVED = 'zola/wedding/website/entity/ENTITY_RECEIVED';
export const ENTITIES_REQUESTED = 'zola/wedding/website/entity/ENTITIES_REQUESTED';
export const ENTITIES_RECEIVED = 'zola/wedding/website/entity/ENTITIES_RECEIVED';
export const ENTITY_SELECTED = 'zola/wedding/website/entity/ENTITY_SELECTED';
export const ENTITY_CREATED = 'zola/wedding/website/entity/ENTITY_CREATED';
export const ENTITY_MOVE = 'zola/wedding/website/entity/ENTITY_MOVE';
export const ENTITY_MOVED = 'zola/wedding/website/entity/ENTITY_MOVED';
export const ENTITIES_RESET = 'zola/wedding/website/entity/ENTITIES_RESET';
export const SUGGESTIONS_REQUESTED = 'zola/wedding/website/entity/SUGGESTIONS_REQUESTED';
export const SUGGESTIONS_RECEIVED = 'zola/wedding/website/entity/SUGGESTIONS_RECEIVED';
export const MEAL_OPTIONS_REQUESTED = 'zola/wedding/website/entity/meal-option/MEAL_OPTIONS_REQUESTED';
export const MEAL_OPTIONS_RECEIVED = 'zola/wedding/website/entity/meal-option/MEAL_OPTIONS_RECEIVED';
export const REQUEST_ADDRESS = 'zola/wedding/website/entity/places/REQUEST_ADDRESS';
export const RECEIVE_ADDRESS = 'zola/wedding/website/entity/places/RECEIVE_ADDRESS';
export const RESET_ADDRESS = 'zola/wedding/website/entity/places/RESET_ADDRESS';



// WEBPACK FOOTER //
// ./src/actions/types/website/EntityActionTypes.js